export const ACCENT = "#7C3AED";
export const GREEN = "#2FA043";

export const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_clarity-session-5/artifacts/0xqv3z2g_velisa_logo.jpg";
export const PORTRAIT_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_clarity-session-5/artifacts/wnfh91r6_velisa%20new%20professional%20picture%20.webp";

export const HOST = {
  name: "Velisa Johnson",
  company: "Yes We Can Lending",
  nmls: "2656519",
  companyNmls: "2656519",
  licenseStates: "Nevada and Texas",
  initials: "VJ",
};

export const WEBINAR = {
  title: "FIRST-TIME BUYER CLARITY",
  date: "THURSDAY, SEPTEMBER 17TH, 2026 AT 6:00 PM PDT",
  duration: "45 MINUTES",
  moduleCount: 5,
  geo: "Nevada & Texas",
};

export const HERO = {
  eyebrow: "FREE 45-MINUTE CLARITY SESSION FOR FIRST-TIME BUYERS — NEVADA & TEXAS",
  h1a: "KNOW YOUR EXACT",
  h1b: "BUYING POWER—",
  h1c: "BEFORE YOU EVER WALK INTO AN OPEN HOUSE",
  blockquote: "What if the 20% down payment you've been told you \u201cneed\u201d isn't actually required to buy your first home?",
};

export const BONUSES = [
  "Free Buying Power & Affordability Analysis",
  "Down Payment & Loan Program Match Guide",
  "Pre-Approval Document Checklist",
  "Full Lender Comparison (20+ Lenders, In Writing)",
  "Direct Text/Call Access to Velisa Through Closing",
];

export const FALSE_BELIEFS = [
  "\u201cI need 20% down to buy my first home.\u201d",
  "\u201cMy credit isn't perfect, so I probably don't qualify yet.\u201d",
  "\u201cI should wait until I have more saved before talking to anyone.\u201d",
];

export const AUDIENCE_CARDS = [
  { icon: "Home", text: "First-Time Buyers Wondering \u201cCan I Even Qualify?\u201d" },
  { icon: "Wallet", text: "W-2, Self-Employed & 1099 Earners Ready to Stop Renting" },
  { icon: "ClipboardList", text: "Buyers Confused About Down Payment & Credit Requirements" },
  { icon: "Target", text: "Anyone Who's Been Told \u201cNot Yet\u201d by a Big Bank" },
  { icon: "Handshake", text: "Buyers Who Want a Real Person, Not a Call Center" },
];

export const MODULES = [
  { title: "DISCOVER YOUR NUMBERS", body: "Your real buying power, income-to-loan ratio, and what \u201caffordable\u201d actually means for your situation." },
  { title: "PREPARE YOUR FILE", body: "The exact documents lenders ask for and how to have them ready before you're asked twice." },
  { title: "MATCH YOUR PROGRAM", body: "FHA, conventional, and low-down-payment options compared side-by-side for first-time buyers." },
  { title: "AVOID THE COMMON MISTAKES", body: "The credit, timing, and paperwork mistakes that get first-time buyers' offers rejected." },
  { title: "KNOW YOUR NEXT STEP", body: "Walk away with a written Game Plan and a clear next move — no pressure, no obligation." },
];

export const TRANSFORMS = [
  "You'll know your exact buying power before you ever tour a home",
  "You'll understand which down payment and credit factors actually matter — and which ones don't",
  "You'll have a written next step with no hard credit pull and no obligation",
];

export const ROADMAP = [
  { step: "01", name: "RESERVE", desc: "Claim your free seat in under 60 seconds. No cost, no credit pull, no strings." },
  { step: "02", name: "WATCH", desc: "Join the live 45-minute session covering all 5 modules — with open Q&A." },
  { step: "03", name: "PREPARE", desc: "Use your checklist and program guide to get your file lender-ready." },
  { step: "04", name: "DECIDE", desc: "Review your written Game Plan and choose your next move — on your timeline." },
];

export const TAKEAWAYS = [
  { icon: "Map", title: "Clearer View", desc: "A grounded picture of what buying your first home in Nevada or Texas actually takes." },
  { icon: "CheckCircle2", title: "Preparation Checklist", desc: "The exact documents and steps to have ready before any lender conversation." },
  { icon: "MessageSquare", title: "Questions to Ask", desc: "The questions that separate prepared buyers from pressured ones — for any lender." },
  { icon: "ClipboardCheck", title: "Optional Next Step", desc: "A no-obligation written Game Plan if you want one. Nothing required." },
];

export const FAQS = [
  { q: "Is the webinar free?", a: "Yes — completely free. This is an educational session about first-time home buying in Nevada and Texas. There is no cost to register or attend, and nothing is sold during the session." },
  { q: "Is this a loan application?", a: "No. Attending is not a loan application and does not start one. It's a 45-minute educational walkthrough of how buying power, down payments, and loan programs actually work for first-time buyers. Any next step is entirely optional." },
  { q: "Will attending affect my credit?", a: "No. Registering and attending requires no credit pull of any kind — hard or soft. You can learn everything in the session without anyone looking at your credit." },
  { q: "Who is this webinar for?", a: "First-time homebuyers in the Nevada and Texas areas — W-2 employees, self-employed, and 1099 earners — who want to understand what they qualify for before touring homes. If a big bank told you \u201cnot yet,\u201d this session is especially for you." },
  { q: "What will be covered?", a: "Five modules: your real buying power, the documents lenders ask for, FHA vs. conventional vs. low-down-payment programs, the mistakes that get first-time offers rejected, and your written next step." },
  { q: "Is it live or on demand?", a: "It's a live session on Thursday, September 17th, 2026 at 6 PM PDT with open Q&A, so you can ask questions about your own first-time buying situation in real time." },
  { q: "What happens after I register?", a: "You'll receive a confirmation with your session access details, plus the Pre-Approval Document Checklist and program guide so you can follow along. No sales calls are required to attend." },
  { q: "Do I have to speak with a loan officer?", a: "No. You can attend, learn, and leave. The optional Buying Power Analysis and written Game Plan are there if you want them — with no obligation and no hard credit pull." },
];

export const TICKER_ITEMS = [
  "45 MINUTES",
  "5 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "NEVADA & TEXAS COVERAGE",
  "NO COST TO ATTEND",
  "FIRST-TIME HOME BUYING SPECIALISTS",
];

export const COMPLIANCE = "This is an educational event. Attendance does not constitute a loan application and does not guarantee approval, a specific interest rate, or a closing timeline. No hard credit pull is required to attend. Velisa Johnson NMLS# 2656519, Yes We Can Lending Corporation LLC NMLS# 2656519. Equal Housing Opportunity. Licensed in Nevada and Texas.";

export const COPYRIGHT = "\u00a9 2026 Yes We Can Lending \u00b7 Velisa Johnson NMLS #2656519";

export const CONSENT_TEXT = "I agree to receive email and SMS communications about this event from Yes We Can Lending. Message and data rates may apply. Consent is not a condition of any purchase or loan approval. Reply STOP to opt out at any time.";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
